module.exports = __webpack_public_path__ + "media/images/players/HERBERT_LUCAS-c125bc861ce59b2d723548a539656f13.png";